import {saveAs} from 'file-saver';

import {IStoredFile} from './file.type';

export class StoredFile implements IStoredFile {
	data = '';
	name?: string = '';

	size?: number = NaN;
	sizeString?: string;

	private _type = '';
	get type(): string {
		return this._type;
	}

	set type(value: string) {
		this._type = value;
		switch (this._type) {
			case 'jpeg':
				this._type = 'jpg';
				break;
		}
	}

	constructor(data: string, type?: string, name?: string, size?: number | string) {
		if (type) this.setType(type);
		if (name) this.name = name;
		if (data != undefined && type == undefined) this.type = data.substring(data.indexOf('/') + 1, data.indexOf(';'));
		this.setData(data);
		if (size) {
			if (typeof size == 'string') this.sizeString = size;
			else if (typeof size == 'number') this.size = size;
		}
	}

	public static fromRes<T extends {image: string; imageType: string}>(res: T): StoredFile {
		return new StoredFile(res?.image, res?.imageType);
	}

	public changeFile(data: string, type?: string) {
		if (type) this.setType(type);
		this.setData(data);
	}

	private get typeClass(): string {
		return this.type == 'pdf' || this.type == 'json' ? 'application' : 'image';
	}

	setType(type: string) {
		this.type = type.includes('/') ? type.substring(type.indexOf('/') + 1) : type;
	}

	setData(data: string) {
		if (data == undefined || data == '') this.data = '';
		else if (data.substring(0, 4) == 'data') {
			this.data = data.substring(data.indexOf(',') + 1);
			this.type = data.substring(data.indexOf('/') + 1, data.indexOf(';'));
		} else this.data = data;
	}

	get fileEncode(): string {
		return this.data;
	}

	get webEncode(): string {
		return this.data == '' ? '' : `data:${this.typeClass}/${this.type};base64,${this.data}`;
	}

	fromJSON(json: IStoredFile): void {
		this.type = json?.type;
		this.data = json?.data;
	}

	toJSON(): IStoredFile {
		return {
			type: this.type,
			data: this.data,
		};
	}

	/* -------------------------------------------------------------------------------------------------------------- */
	downloadFile(fileName: string): void {
		const binaryString = atob(this.data);
		const bytes = new Uint8Array(binaryString.length);
		for (let i = 0; i < binaryString.length; i++) {
			bytes[i] = binaryString.charCodeAt(i);
		}
		const blob = new Blob([bytes], {type: `application/${this.type}`});
		saveAs(blob, fileName);
	}

	/* -------------------------------------------------------------------------------------------------------------- */
	public static asWebEncode(data: string, type?: string): string {
		return new StoredFile(data, type).webEncode;
	}

	public static asFileEncode(data: string, type?: string): string {
		return new StoredFile(data, type).fileEncode;
	}
}
